var map = {
	"./ADVE/Labels.json": [
		80431,
		431
	],
	"./Global/Labels.json": [
		84428,
		428
	],
	"./TRUS/Labels.json": [
		74069,
		69
	],
	"./UNIV/Labels.json": [
		30269,
		269
	],
	"./VITU/Labels.json": [
		35718,
		718
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 38461;
module.exports = webpackAsyncContext;